module.exports = __webpack_public_path__ + "media/images/front/materiales_sup_m-8b73bb52f8e7c73a22e693652c736d44.png";